"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotTestListPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="bot-test-list-page">
        <crud-table 
            title="botTest.list"
            addText="botTest.create"
            resource="botTest"
            searchPlaceholder="botTest.searchPlaceholder"
            indexEndpoint="bot-test.index" 
            listEndpoint="bot-test.list"
            deleteEndpoint="bot-test.delete" 
            editRoute="/bot-test/edit/:id" 
            addRoute="/bot-test/create"
            :actions="${x => x.baseActions}"
            :columns="${x => x.tableColumns}">
        </crud-table>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host .empty-icon i {
  font-size: 3rem;
  color: var(--text_color);
}
:host .badge {
  font-size: 0.75rem;
}
:host .btn-list {
  gap: 0.25rem;
}
:host .table-striped > tbody > tr:nth-of-type(odd) > td,
:host .table-striped > tbody > tr:nth-of-type(odd) > th {
  background-color: var(--tblr-bg-surface-secondary);
}
:host .page-link {
  border: 0;
  color: var(--primary-color);
}
:host .page-link:hover {
  background-color: var(--primary-color);
  color: white;
}
:host .page-item.active .page-link {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}
:host .page-item.disabled .page-link {
  color: var(--text_color);
}`;
const shadowOptions = { "mode": "open" };
let BotTestListPage = class BotTestListPage extends client_1.RWSViewComponent {
    constructor() {
        super();
        this.baseActions = [
            {
                key: 'preview',
                icon: 'simple-icon-magnifier',
                label: '',
                variant: 'info',
                tooltip: 'avatar.tooltips.preview'.t(),
                tooltipDirection: 'left',
                handler: async (id) => {
                    component_1.SiteMenu.goto.bind(this)(`/bot-test/preview/${id}`);
                }
            }
        ];
        this.tableColumns = [
            {
                key: 'name',
                header: 'botTest.name'.t(),
                formatter: (name) => `<strong>${name}</strong>`
            },
            {
                key: 'testDate',
                header: 'botTest.date'.t(),
                formatter: (testDate) => {
                    if (!testDate)
                        return '-';
                    return new Date(testDate).toLocaleDateString();
                }
            },
            {
                key: 'description',
                header: 'botTest.description'.t(),
                formatter: (description) => description || '-'
            },
            {
                key: 'active',
                header: 'botTest.active'.t(),
                formatter: (active) => {
                    const badgeClass = active ? 'success' : 'danger';
                    const text = active ? 'common.yes'.t() : 'common.no'.t();
                    return `<span class="badge badge-${badgeClass}">${text}</span>`;
                }
            }
        ];
    }
};
exports.BotTestListPage = BotTestListPage;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestListPage.prototype, "baseActions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], BotTestListPage.prototype, "tableColumns", void 0);
exports.BotTestListPage = BotTestListPage = __decorate([
    (0, client_1.RWSView)('bot-test-list', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __metadata("design:paramtypes", [])
], BotTestListPage);
BotTestListPage.defineComponent();
